<template>
  <app-modal name="company-profile-modal" :title="title" :is-submitting="isLoading" @before-open="beforeOpen"  @on-ok="onOk">
    <p class="desc">{{ $t('user.updateBusinessDesc') }}</p>
    <app-form
      ref="form"
      @on-submit="onSubmit"
      :schema="schema"
      :data="formModel"
    />
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import { mapActions } from 'vuex';
import AppForm from '@/components/app-form/';

export default {
  name: 'CompanyProfileModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: this.$t('user.updateBusinessInformation'),
      isLoading: false,
      formModel: {
        full_name: null,
        tax_code: null,
        company_address: null,
      },
      schema: [
        {
          name: 'full_name',
          label: this.$t('user.name'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.name')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'tax_code',
          label: this.$t('user.taxCode'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.taxCode')}`,
          type: 'input',
          validation: { required: true, taxCode: true },
        },
        {
          name: 'company_address',
          label: this.$t('user.companyAddress'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.companyAddress')}`,
          type: 'input',
          validation: 'required',
        },
      ],
    };
  },
  methods: {
    ...mapActions('auth', ['updateCompanyInfo', 'getSubscriptionsMonitor']),
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.isLoading = true;
          this.updateCompanyInfo(formModel).then(() => {
            this.$bus.emit('company-profile-updated');
            this.getSubscriptionsMonitor();
            this.$modal.hide('company-profile-modal', { isOk: true });
          }).finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
        }
      });
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeOpen() {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.formModel = {
        ...currentUser.company,
      };
    },
  },
};
</script>
<style scoped>
  .desc {
    font-size: 13px;
    text-align: center;
    padding: 1rem;
    background: #CCE4F6;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/portal-components/user/company-profile-modal.vue